import Report from '@/views/report/Report.vue'
import Query from '@/views/query/Query.vue'
import Detail from '@/views/query/Detail.vue'

export default [
    {
        // 报备表单
        path: '/report',
        name: 'Report',
        component: Report,
        meta: {
            requireAuth: true,
        }
    },
    {
        // 报备查询
        path: '/query',
        name: 'Query',
        component: Query
    },
    {
        // 报备详情
        path: '/query/detail/:id',
        name: 'Detail',
        component: Detail
    }
]
